/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Audio_Processing_TitleInputs */



/**
* | output |
* | --- |
* | "Audio Processing" |
*
* @param {Audio_Description_Export_Audio_Processing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_audio_processing_title = /** @type {((inputs?: Audio_Description_Export_Audio_Processing_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Audio_Processing_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioverarbeitung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка звука")
	if (locale === "es") return /** @type {LocalizedString} */ ("Procesamiento de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频处理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ処理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो प्रोसेसिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processamento de áudio")
	return /** @type {LocalizedString} */ ("Audio Processing")
});